<template>
	<div class="improcing layui-layout layui-layout-admin">
		<div class="layui-header zt_color layui-row f_row al_itm jc_ct">
			<div class="px24" style="color:#fff;">完善资料</div>
		</div>
		<form class="layui-form px16" action="">
			<table class="layui-table bge" style="width:800px;margin: 50px auto;">
				<tbody class="align_center px16">
					<tr>
						<td class="ft_wt">姓名</td>
						<td>
							<input type="text" name="names" lay-reqText="请输入姓名" maxlength="15" lay-verify="required">
						</td>
						<td class="ft_wt">性别</td>
						<td class="text">
							<input type="radio" name="sex" value="1" title="男" checked>
							<input type="radio" name="sex" value="2" title="女">
						</td>
					</tr>
					<tr>
						<td class="ft_wt">出生年月</td>
						<td>
							<input type="text" id="birthday" name="birthday" readonly lay-reqText="请输入出生年月" lay-verify="required">
						</td>
						<td class="ft_wt">民族</td>
						<td>
							<div style="display: flex;">
								<div><input type="text" name="nation" lay-reqText="请输入民族" lay-verify="required" style="text-align: right;"></div>
								<div style="width: 50px;margin-left: 5px;">族</div>
							</div>
						</td>
					</tr>
					<tr>
						<td class="ft_wt">联系电话</td>
						<td>
							<input type="phone" name="mobile" maxlength="11" lay-reqText="请输入联系电话" lay-verify="required|phone">
						</td>
						<td class="ft_wt">从业年限</td>
						<td>
							<div style="display: flex;">
								<div><input type="text" name="work_life" lay-reqText="请输入从业年限" lay-verify="required|number" style="text-align: right;"></div>
								<div style="width: 50px;margin-left: 5px;">年</div>
							</div>
						</td>
					</tr>
					<tr>
						<td class="ft_wt">合作意向</td>
						<td>
							<div class="f_row al_itm jc_ct text">
								<input type="radio" name="work_type" value="1" title="全职" checked>
								<input type="radio" name="work_type" value="2" title="兼职">
							</div>
						</td>
						<td class="ft_wt">QQ</td>
						<td>
							<input type="text" name="qq" maxlength="20" lay-reqText="请输入QQ" lay-verify="required">
						</td>
					</tr>
					<tr>
						<td class="ft_wt">银行卡号</td>
						<td colspan="3">
							<input type="text" name="bank_card" maxlength="19" lay-reqText="请输入银行卡号" lay-verify="required">
						</td>
					</tr>
					<tr>
						<td class="ft_wt">联系地址</td>
						<td colspan="3">
							<input type="text" name="contact_address" lay-reqText="请输入联系地址" maxlength="30" lay-verify="required">
						</td>
					</tr>
					<tr>
						<td class="ft_wt">工作邮箱</td>
						<td>
							<input type="text" name="email" lay-reqText="请输入工作邮箱" maxlength="30" lay-verify="email">
						</td>
						<td class="ft_wt">现所在地</td>
						<td>
							<input type="email" name="now_address" maxlength="30" lay-reqText="请输入现所在地" lay-verify="required">
						</td>
					</tr>
					<tr>
						<td class="ft_wt" colspan="4">工作经历</td>
					</tr>
					<tr>
						<td class="ft_wt">职位</td>
						<td class="ft_wt">就职公司</td>
						<td class="ft_wt">入职时间</td>
						<td class="ft_wt">离职时间</td>
					</tr>
					<tr v-for="(item,i) in expList" :key="i">
						<td>
							<input type="text" v-model="item.a" :disabled="i > 0 && (expList[i-1].a == '' || expList[i-1].b == '' || expList[i-1].c == '' || expList[i-1].d == '')  ? true : false">
						</td>
						<td>
							<input type="text" v-model="item.b" :disabled="i > 0 && (expList[i-1].a == '' || expList[i-1].b == '' || expList[i-1].c == '' || expList[i-1].d == '')  ? true : false">
						</td>
						<td>
							<input type="text" :id="'start'+i" readonly :disabled="i > 0 && (expList[i-1].a == '' || expList[i-1].b == '' || expList[i-1].c == '' || expList[i-1].d == '')  ? true : false">
						</td>
						<td>
							<input type="text" :id="'end'+i" readonly :disabled="i > 0 && (expList[i-1].a == '' || expList[i-1].b == '' || expList[i-1].c == '' || expList[i-1].d == '')  ? true : false">
						</td>
					</tr>
					<tr>
						<td class="ft_wt">自我介绍</td>
						<td colspan="3" style="height:80px;">
							<input name="about_mine" style="height:80px;" maxlength="50" type="text" lay-reqText="请输入自我介绍" lay-verify="required">
						</td>
					</tr>
				</tbody>
			</table>			
			<button type="button" class="layui-btn zt_color px16" lay-submit lay-filter="impros" style="width:30%;margin: 50px 0 100px 35%;">提交注册</button>
		</form>
		<div class="layui-footer align_center zt_color f_row al_itm jc_ct" style="left:0;color:#fff;">
			<span>© 桃琼之瑶SMT活动钢网</span>
		</div>
		<div v-show="showOks" class="rgstOk f_col al_itm jc_ct">
			<i class="layui-icon layui-icon-ok-circle zt_txt_color px200"></i>
			<span class="px24">注册成功!</span>
			<span @click="goHomes" class="px16 zt_txt_color d_line pointer">{{times}}S后跳转</span>
		</div>
		<div id="qrCode" style="display: none;">
			<img src="../assets/qrcode.png" />
			<p>亲爱的，请打开手机微信扫描上图二维码，关注我们的公众号并且选择绑定。您将及时收到我们平台给您推送的订单实时信息，桃琼之瑶为您助力。假如您不绑定我们的公众号，给您带来的不便及损失，平台将不承担相关责任。</p>
			<button class="layui-btn zt_color" style="display: block;margin: 20px auto 0;" @click="onClose">已关注</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'login',
		data() {
			return {
				forms: '',
				times: 3,
				showOks: false,
				clasIndex: 1,
				expList: [{
						a: '',
						b: '',
						c: '',
						d: ''
					},
					{
						a: '',
						b: '',
						c: '',
						d: ''
					},
					{
						a: '',
						b: '',
						c: '',
						d: ''
					},
					{
						a: '',
						b: '',
						c: '',
						d: ''
					},
					{
						a: '',
						b: '',
						c: '',
						d: ''
					}
				]
			}
		},
		created() {

		},
		mounted() {
			let _this = this;
			setTimeout(() => {
				layui.use(['form', 'layer', 'element', 'laydate'], () => {
					_this.forms = layui.form;
					var layer = layui.layer;
					var laydate = layui.laydate;
					laydate.render({
						elem: '#birthday'
					});
					laydate.render({
						elem: '#start0',
						done: function(value) {
							_this.expList[0].c = value;
						},
					});
					laydate.render({
						elem: '#end0',
						done: function(value) {
							_this.expList[0].d = value;
						},
					});
					laydate.render({
						elem: '#start1',
						done: function(value) {
							_this.expList[1].c = value;
						},
					});
					laydate.render({
						elem: '#end1',
						done: function(value) {
							_this.expList[1].d = value;
						},
					});
					laydate.render({
						elem: '#start2',
						done: function(value) {
							_this.expList[2].c = value;
						},
					});
					laydate.render({
						elem: '#end2',
						done: function(value) {
							_this.expList[2].d = value;
						},
					});
					laydate.render({
						elem: '#start3',
						done: function(value) {
							_this.expList[3].c = value;
						},
					});
					laydate.render({
						elem: '#end3',
						done: function(value) {
							_this.expList[3].d = value;
						},
					});
					laydate.render({
						elem: '#start4',
						done: function(value) {
							_this.expList[4].c = value;
						},
					});
					laydate.render({
						elem: '#end4',
						done: function(value) {
							_this.expList[4].d = value;
						},
					});
					_this.forms.on('submit(impros)', (e) => {
						let t = 0;
						let cutting = [];
						_this.expList.forEach((val) => {
							if(val.a != '' && val.b != '' && val.c != '' && val.d != '') {
								t += 1;
							}
						})
						if(t != 0) {
							if(t < 5 && (_this.expList[t].a != '' || _this.expList[t].b != '' || _this.expList[t].c != '' || _this.expList[t].d != '')) {
								layer.msg('请完善工作经历', {
									icon: 2,
									anim: 6
								});
								return false;
							}
							for(let i = 0; i < t; i++) {
								let obj = {};
								obj.position = _this.expList[i].a;
								obj.company = _this.expList[i].b;
								obj.in_time = _this.expList[i].c;
								obj.out_time = _this.expList[i].d;
								cutting.push(obj);
							}
							api.fillInfo({
								token: _this.getCookie('token'),
								name: e.field.names,
								sex: e.field.sex,
								birthday: e.field.birthday,
								nation: e.field.nation,
								mobile: e.field.mobile,
								work_life: e.field.work_life,
								work_type: e.field.work_type,
								qq: e.field.qq,
								bank_card: e.field.bank_card,
								contact_address: e.field.contact_address,
								now_address: e.field.now_address,
								email: e.field.email,
								work_info: JSON.stringify(cutting),
								about_mine: e.field.about_mine,
							}).then((res) => {
								if(res.code == 1) {
									layer.open({
										title: '',
										type: 1,
										content: $('#qrCode'),
										shade: 0.3,
										cancel: function(index, layero) {
											_this.showOks = true;
											let jshi = setInterval(() => {
												if(_this.times >= 1) {
													_this.times = _this.times - 1
												} else {
													clearInterval(jshi);
													_this.$router.replace('login');
												}
											}, 1000)
										}
									});
								} else {
									layer.msg(res.msg, {
										icon: 2,
										anim: 6
									});
								}
							})
						} else {
							layer.msg('至少填写一条工作经历', {
								icon: 2,
								anim: 6
							});
						}
					});
					_this.forms.render();
				});
				_this.forms.render();
			}, 100)
		},
		methods: {
			goHomes() {
				this.$router.replace('login');
			},
			onClose() {
				let _this = this;
				this.showOks = true;
				layer.closeAll();
				let jshi = setInterval(() => {
					if(_this.times >= 1) {
						_this.times = _this.times - 1
					} else {
						clearInterval(jshi);
						_this.$router.replace('login');
					}
				}, 1000)
			},
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	#qrCode {
		width: 300px;
		padding: 20px;
	}
	
	#qrCode img {
		display: block;
		width: 300px;
		height: 300px;
		margin-bottom: 10px;
	}
	
	#qrCode p {
		font-size: 16px;
		text-align: center;
		color: #FF494C;
	}
	
	.layui-table tbody tr:hover,
	.layui-table thead tr,
	.layui-table-click,
	.layui-table-header,
	.layui-table-hover,
	.layui-table-mend,
	.layui-table-patch,
	.layui-table-tool,
	.layui-table[lay-even] tr:nth-child(even) {
		background-color: transparent;
	}
	
	.rgstOk {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: #fff;
		z-index: 99999;
	}
	
	.requires::before {
		content: url('../assets/require.png');
		width: 20px;
		height: 20px;
		position: absolute;
		top: 50%;
		margin-top: -10px;
		left: -24px;
	}
	
	.bge td {
		line-height: 45px;
		min-height: 45px;
		padding: 0;
		border-width: 1px;
		border-color: #000;
		position: inherit;
	}
	
	.bge input[type='text'],
	.bge input[type='phone'],
	.bge input[type='email'] {
		width: 100%;
		text-align: center;
		display: block;
		height: 45px;
		border: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/improving.vue